export default __webpack_public_path__ + "static/media/a-mex-desert-2-1point-5-768x512.e9d48d36.jpg";